import { Component, Input } from '@angular/core';
import { ModalService } from '../../../services/modal.service';
import { ButtonComponent } from '../../../../shared/components/buttons/button/button.component';

@Component({
    selector: 'app-form-modal-dialog',
    templateUrl: './form-modal-dialog.component.html',
    styleUrl: './form-modal-dialog.component.scss',
    imports: [ButtonComponent],
})
export class FormModalDialogComponent {

    constructor(private readonly modalService: ModalService) {
    }

    @Input({ required: true })
    submit: () => void;

    close() {
        this.modalService.pop();
    }

}
